import React from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {VisualizationInstance} from '../../../model/viz/VisualizationInstance';
import {Chart} from "../../../../component/chart/Chart";
import {PieChartBuilder} from "../../../../utils/chart/PieChartBuilder";
import {services} from "../../../../application/service/services";
import './distributionViz.scss';
import {connect} from "react-redux";
import {ClickableViz} from "../ClickableViz";
import {
    FieldVizFeedbacksQueryContext,
    MultiFieldsVizFeedbacksQueryContext,
    VizFeedbacksQueryContext
} from "../../../model/viz/VizFeedbacksQueryContext";
import {FieldValue} from "../../../../application/model/field/FieldValue";
import {CSVExportableViz} from "../CSVExportableViz";
import {BarChartBuilder} from "../../../../utils/chart/BarChartBuilder";
import {TableItem} from "../table/AbstractTableViz";

interface DistributionVizProps extends WithTranslation {
    viz: VisualizationInstance,
    setRightPanelOpen: (opened: boolean) => void,
    openFeedbacksPanel: (viz: ClickableViz, panelTitle: string) => void
}


interface StateProps {
    clickItem: TableItem
}

class DistributionChartVizComponent extends React.PureComponent<DistributionVizProps> implements ClickableViz, CSVExportableViz {


    state: StateProps = {
        clickItem: null,
    }
    private chartBuilder: PieChartBuilder | BarChartBuilder;

    private getFieldsFromItem(clickItem: any): Array<FieldVizFeedbacksQueryContext> {
        const result = [];
        if (clickItem.parent) {
            result.push(...this.getFieldsFromItem(clickItem.parent));
        }
        const field = new FieldVizFeedbacksQueryContext();
        field.field = clickItem.field;
        field.selectedValue = clickItem.fieldValue;

        /*result.field = viz.definition.params.field;
            result.selectedValue = this.state.clickItem.group;*/
        result.push(field);
        return result;
    }

    getFeedBacksQueryContext(): VizFeedbacksQueryContext {
        const result = new MultiFieldsVizFeedbacksQueryContext();
        if (this.state.clickItem) {
            const {viz} = this.props;
            result.fields = this.getFieldsFromItem(this.state.clickItem);
        }
        return result;
    }

    getClickedFieldValue(): FieldValue {
        if (this.state.clickItem) {
            const {viz} = this.props;
            return services.getFieldsService().findFieldValue(viz.definition.params.field, this.state.clickItem.fieldValue);
        }
        return null;
    }

    onclick(event, items: any[], chart: Chart) {
        if(items && items.length === 0) return ;
        this.state.clickItem = items[0].element.$context.raw.item;
        const label = services.getFieldsService().findFieldValue(this.state.clickItem.field, this.state.clickItem.fieldValue)?.getLabel(this.props.t) || this.state.clickItem.fieldValue;
        this.props.openFeedbacksPanel(this, label);
    }

    getDataToExport(): any[][] {
        return this.chartBuilder.getDataToExport();
    }

    render() {
        let {viz, t} = this.props;
        return <div className="distributionChartViz">
            <div className='distributionChartViz__chartWrapper'>
                {viz.definition.spec.uiParams.chartType === 'pie' ?
                    this.getPieChart() :
                    this.getBarChart()
                }
            </div>
        </div>;
    }

    private getBarChart() {
        let {viz, t} = this.props;
        this.chartBuilder = new BarChartBuilder(viz, t, true);
        // @ts-ignore
        this.chartBuilder.showLegend(true)
            .onclick(this.onclick.bind(this))
            .withData(viz.data)
            .legend(viz.definition.uiParams.legend)
            .displayLabelsInline(true);
        return <Chart chartBuilder={this.chartBuilder}/>;
    }

    private getPieChart() {
        let {viz, t} = this.props;
        this.chartBuilder = new PieChartBuilder(viz, t);
        this.chartBuilder.showLegend(true)
            .onclick(this.onclick.bind(this))
            .withData(viz.data)
            .legend(viz.definition.uiParams.legend)
            .displayLabelsInline(true);

        return <Chart chartBuilder={this.chartBuilder}/>;
        //return <SunburstChart data={data} config={config}/>;
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        openFeedbacksPanel: (viz: ClickableViz, panelTitle: string) => {
            dispatch.dashboard.openFeedBackPanel({viz, panelTitle});
        },
    }
};

export const DistributionChartViz = withTranslation(undefined, {withRef: true})(connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(DistributionChartVizComponent));

